import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { SelectCustom } from '../../../../common/selectCustom'
import { formatText } from '../../../../helpers/value'
import { Z_INDEX } from '../../../../utils/common'
import { selectProfileById } from '../../store/slice'
import { changeSettingTable, selectDataTable } from '../store/slice'

export const EventCell = ({ rowId, isCreate }) => {
  const dataRow = useSelector(selectDataTable(rowId))

  return (
    <div className="dFlex alignItemsCenter gap1">
      {formatText(dataRow.criteriaName)}
      {dataRow.conditionSettings && (
        <YearOfOperationType isCreate={isCreate} data={dataRow} rowId={rowId} />
      )}
    </div>
  )
}

const YearOfOperationType = ({ isCreate, data, rowId }) => {
  const dispatch = useDispatch()
  const [search] = useSearchParams()

  const id = search.get('profileId')

  const isDefaultProfiles = useSelector(
    selectProfileById(+id, 'isDefaultProfile'),
  )

  const isDisable = isCreate
    ? false
    : isDefaultProfiles || !data.sendNotification || data.disabled

  const onChangeType = (value) => {
    dispatch(
      changeSettingTable({
        id: rowId,
        value: {
          ...data,
          conditions: [
            {
              conditionId: value.value,
            },
          ],
        },
      }),
    )
  }

  useEffect(() => {
    if (!data?.conditions?.[0]?.conditionId) {
      onChangeType({
        value: data.conditionSettings[0].conditionId,
      })
    }
  }, [data])

  return (
    <SelectCustom
      activeItem={{ value: data?.conditions?.[0]?.conditionId }}
      data={data.conditionSettings.map((item) => ({
        ...item,
        label: item.conditionName,
        value: item.conditionId,
        isI18n: false,
      }))}
      chooseItem={onChangeType}
      disabled={!!isDisable}
      isI18n
      zIndex={Z_INDEX.MODAL + 1}
      style={{
        backgroundColor: '#D5D5D5',
        color: !!isDisable ? '#9C9C9C' : '#3A414B',
        padding: '0px 27px 0px 12px',
        cursor: !!isDisable ? 'not-allowed' : 'pointer',
      }}
      styleDropdown={{ whiteSpace: 'nowrap' }}
    />
  )
}
